import { useState } from "react"
import Modal from "aldoo-ra/Modal"
import Button from "aldoo-ra/Button"
import Input from "aldoo-ra/Input"
import Spinner from "aldoo-ra/Spinner"
import { showNotification } from "aldoo-ra/Notification"
import { AIRewriteLocalization } from "./api"

export default function LocalizationAIRewriteDialog({ originalText, onAccept, onClose }) {
  const [directions, setDirections] = useState("")
  const [result, setResult] = useState("")
  const [loading, setLoading] = useState(false)

  const handleRewrite = async () => {
    if (!originalText?.trim() && !directions?.trim()) {
      showNotification({ message: "Provide text or directions", className: "bg-admin_error text-white" })
      return
    }
    setLoading(true)
    setResult("")
    try {
      const res = await AIRewriteLocalization({ text: originalText, directions })
      if (res?.error) {
        showNotification({ message: res.error, className: "bg-admin_error text-white" })
        return
      }
      setResult(res?.result || "")
    } catch {
      showNotification({ message: "AI rewrite failed", className: "bg-admin_error text-white" })
    } finally {
      setLoading(false)
    }
  }

  const handleUse = () => {
    if (!result) return
    onAccept(result)
    onClose()
  }

  return (
    <Modal
      variant="admin"
      title="AI Rewrite"
      isOpen={true}
      onClose={onClose}
      closeOnEscape={true}
      className="w-full md:w-[700px]"
      footerContent={
        <div className="flex items-center justify-end gap-2 p-4">
          <Button variant="admin_secondary" onClick={onClose}>Cancel</Button>
          <Button
            variant="admin_secondary"
            onClick={handleRewrite}
            disabled={loading}
          >
            {loading ? "Rewriting…" : "Rewrite"}
          </Button>
          {result && !loading && (
            <Button variant="admin_primary" onClick={handleUse}>
              Use
            </Button>
          )}
        </div>
      }
    >
      <div className="flex flex-col gap-4 p-4">
        {/* Original */}
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold text-admin_text_secondary uppercase tracking-wide">Original</span>
          <div className="min-h-[48px] rounded border border-admin_bordered bg-admin_canvas px-3 py-2 text-sm text-admin_text_secondary whitespace-pre-wrap leading-relaxed">
            {originalText || <span className="italic opacity-50">No original text</span>}
          </div>
        </div>

        {/* Directions */}
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold text-admin_text_secondary uppercase tracking-wide">Directions</span>
          <Input
            variant="admin"
            value={directions}
            onChange={(e) => setDirections(e.target.value)}
            multiline
            placeholder={"e.g. Make it more formal\nSimplify the language\nTranslate to a different tone"}
            className="h-24 resize-none w-full"
          />
        </div>

        {/* Result */}
        <div className="flex flex-col gap-1">
          <span className="text-xs font-semibold text-admin_text_secondary uppercase tracking-wide">Result</span>
          {loading ? (
            <div className="min-h-[48px] flex items-center gap-2 rounded border border-admin_bordered bg-admin_canvas px-3 py-2">
              <Spinner variant="admin-primary-thin" />
              <span className="text-sm text-admin_text_secondary">Generating…</span>
            </div>
          ) : (
            <Input
              variant="admin"
              value={result}
              onChange={(e) => setResult(e.target.value)}
              multiline
              placeholder="Result will appear here…"
              className="h-24 resize-none w-full"
            />
          )}
        </div>
      </div>
    </Modal>
  )
}
